import { SelectIpQuoteMutation } from '@generated/gql/graphql';
import { useInsuranceHandler } from '@hooks/useInsuranceHandler';
import { IncomeProtectorInsuranceQuote } from '@src/types/insurance';

import { deselectIpQuoteMutation, selectIpQuoteMutation } from './query';
import { useTrackIpSelected } from './useTrackIpSelected';

const useIncomeProtectorHandler = (
  quote: IncomeProtectorInsuranceQuote,
  basketId: string,
  onSelectCompleted?: () => void,
  onDeselectCompleted?: () => void
) => {
  const { trackIpSelected } = useTrackIpSelected();

  return useInsuranceHandler<SelectIpQuoteMutation>({
    quoteId: quote.id,
    basketId,
    selectMutation: selectIpQuoteMutation,
    deselectMutation: deselectIpQuoteMutation,
    onSelected: trackIpSelected,
    onSelectCompleted,
    onDeselectCompleted,
  });
};

export { useIncomeProtectorHandler };
